

import axios from "axios";
import { useState, useEffect } from "react";
import { BusinessUser } from "../../CRUD/CampSites/types";
import deleteBusinessUser from "./deleteBusinessUser";

interface BusinessUserDetailProps {
  businessUser: BusinessUser;
  onEdit: (businessUser: BusinessUser, isEditing: boolean) => void;
  onClose: () => void;
}

const BusinessUserDetail: React.FC<BusinessUserDetailProps> = ({
  businessUser,
  onClose,
  onEdit,
}) => {
  const [isSending, setIsSending] = useState(false);
  const [codeSent, setCodeSent] = useState(businessUser.isCodeSent);

  useEffect(() => {
      const fetchBusinessUser = async () => {
          try {
              const response = await axios.get(`${process.env.REACT_APP_API_URL}/BusinessUser/getBusinessUser/${businessUser.id}`);
              const data = response.data as { data: { isCodeSent: boolean } };
              setCodeSent(data.data.isCodeSent); // Access the nested data object
              console.log('Business user details:', response.data);
          } catch (error) {
              console.error('Error fetching business user details', error);
          }
      };

      fetchBusinessUser();
  }, [businessUser.id]);

  const handleBack = () => {
      onClose();
  };

  const handleEdit = () => {
      onEdit(businessUser, true);
  };

  const handleDeleteBusinessUser = async (Id: number) => {
      if (window.confirm("Are you sure you want to delete this business user?")) {
          try {
              await deleteBusinessUser(Id);
              alert("Business user deleted successfully.");
              onClose();
              // Optionally, you can refresh the bookings list or remove the deleted booking from the state
          } catch (error) {
              console.error("Error deleting business user:", error);
              alert("Failed to delete business user.");
          }
      }
  };

  const handleSendBusinessCode = async () => {
      setIsSending(true);
      try {
          const response = await axios.post(
              `${process.env.REACT_APP_API_URL}/BusinessUser/sendBusinessUserCodeEmail`,
              {
                  businessUserId: businessUser.id,
                  businessCode: businessUser.businessCode,
              },
              {
                  headers: {
                      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                  },
              }
          );
          alert(response.data); // Display the success message from the response
          setCodeSent(true);
      } catch (error) {
          console.error("Error sending business code:", error);
          alert("Failed to send business code.");
          setCodeSent(false);
      } finally {
          setIsSending(false);
      }
  };

  return (
    <div className="container mt-4">
      <div className="card business-details">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5>Tour Operator Details</h5>
        </div>
        <div className="card-body">
        <div className="row mb-3">
            <div className="col-sm-4 font-weight-bold">Company Name:</div>
            <div className="col-sm-8">{businessUser.companyName}</div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-4 font-weight-bold">Name:</div>
            <div className="col-sm-8">{businessUser.name}</div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-4 font-weight-bold">Email:</div>
            <div className="col-sm-8">{businessUser.email}</div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-4 font-weight-bold">Phone Number:</div>
            <div className="col-sm-8">{businessUser.phoneNumber}</div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-4 font-weight-bold">Address:</div>
            <div className="col-sm-8">{businessUser.address}</div>
          </div>
          {businessUser.address2 && (
            <div className="row mb-3">
              <div className="col-sm-4 font-weight-bold">Address 2:</div>
              <div className="col-sm-8">{businessUser.address2}</div>
            </div>
          )}
          <div className="row mb-3">
            <div className="col-sm-4 font-weight-bold">City:</div>
            <div className="col-sm-8">{businessUser.city}</div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-4 font-weight-bold">Zip Code:</div>
            <div className="col-sm-8">{businessUser.zipCode}</div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-4 font-weight-bold">Country:</div>
            <div className="col-sm-8">{businessUser.country}</div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-4 font-weight-bold">Business Code:</div>
            <div className="col-sm-8">{businessUser.businessCode}</div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-4 font-weight-bold">
              Code sent to business user?
            </div>
            <div className="col-sm-8">{codeSent ? "yes" : "no"}</div>
          </div>
          {!codeSent && (
            <div className="row mb-3">
              <div className="col-sm-12">
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={handleSendBusinessCode}
                  disabled={isSending}
                >
                  {isSending ? "Sending..." : "Send Business Code"}
                </button>
              </div>
            </div>
          )}
        </div>
        <div className="card-footer d-flex justify-content-end">
          <button
            className="btn btn-sm btn-outline-danger me-2"
            onClick={() => handleDeleteBusinessUser(businessUser.id)}
          >
            <i className="fas fa-trash-alt"></i> Delete
          </button>
          <button
            className="btn btn-sm btn-outline-primary me-2"
            onClick={handleEdit}
          >
            <i className="fas fa-edit"></i> Edit
          </button>
          <button
            className="btn btn-sm btn-outline-secondary me-2"
            onClick={handleBack}
          >
            <i className="fas fa-times"></i> Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default BusinessUserDetail;